module.exports = __webpack_public_path__ + "static/debugger.8950e3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/debugger.png
// module id = 127
// module chunks = 35783957827783 162898551421021